module.exports = __webpack_public_path__ + "static/Registration-c3ec0d7d2e98067c4417f33d42339ab5.mp4";